<template>
    <b-modal id="permission_delete" ref="permission_delete" header-class="no-border" footer-class="no-border"
             @hidden="$emit('close')"
             :title="setTitle">
        You can't revert back your action if you delete this data. For further query, contact Database Manager!

        <template slot="modal-footer">
            <b-button size="sm" variant="secondary" @click="hideModal('permission_delete')" v-text="'Cancel'"/>

            <state-button size="sm" v-if="mode === 'permission'" variant="danger" :click="deletePermission">Delete</state-button>
        </template>
    </b-modal>
</template>

<script>
import StateButton from "../../../../components/Common/StateButton";

export default {
    name: "PermissionDeleteModal",

    components: {
        StateButton
    },

    props: [
        'permission', 'mode',
    ],

    computed: {
        setTitle() {
            if (this.mode === 'permission') {
                return 'Delete ' + this.permission.data.attributes.name + '?';
            } else {
                return 'Delete permission?';
            }
        },
    },

    methods: {
        hideModal(refname) {
            this.$refs[refname].hide();
        },

        deletePermission() {
            return new Promise((success, fail) => {
                this.$store.dispatch('deletePermission', this.permission)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('deleted-permission');

                            this.$notify('error filled', 'Success!', 'Deleted the permission!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('permission_delete');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },
    }
}
</script>

<style scoped>

</style>
